<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="pvd-container p-xxsmall-top">
    <p
      class="footnotes"
      v-html="content"
    />
  </div>
</template>

<script>
export default {
  name: 'FootnoteComponent',
  props: {
    content: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.footnotes {
  font-size: 0.75em;
  color: #666;
}
</style>
